import { createSlice } from "@reduxjs/toolkit";
import { numericalString } from "../types";
import { AttackModeData } from "../types/attackMode";

const initialState = {
  attackModeStates: {},
  attackLosses: [],
} as AttackModeData;

export const attackModeSlice = createSlice({
  name: "attackMode",
  initialState,
  reducers: {
    setAttackModeData: (state, action) => {
      const attackModeData = action.payload;
      for (const driverAttackModeState of attackModeData.attackModeStates ??
        []) {
        const { driver, attackModeState } = driverAttackModeState;
        state.attackModeStates[driver as numericalString] = attackModeState;
      }
      if (attackModeData.attackLosses) {
        state.attackLosses = attackModeData.attackLosses;
      }
    },
    setDriverAttackModeState: (state, action) => {
      const { driverId, attackModeState } = action.payload;
      state.attackModeStates[driverId] = attackModeState;
    },
    setAttackLoss: (state, action) => {
      state.attackLosses.push(action.payload);
    },
  },
});

export const { setAttackModeData, setDriverAttackModeState, setAttackLoss } =
  attackModeSlice.actions;
export default attackModeSlice.reducer;
